export const menuAccessTranslation = [
    'کاربران',
    'ادمین',
    'فروشنده'
]